import React from 'react'

import Navbar from '../inc/Navbar'
import TeacherForm from './TeacherForm'



function Teacherpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        
    
                    <br/>
                    <div className='teacherbackground'>
                        <br/>
                         <div className="album py-0">
        <div className="container">
                       <h2 className='mt-3' style={{color:"darkBlue"}}>Form Submission Timeout</h2>
                       </div>
                       </div>
        <TeacherForm/>
       <br/>
       <br/>
        </div>
        
    </div>
  )
}

export default Teacherpage